<template>
    <div>
        <template v-if="vendor_payment_report === true && vendor_categories != null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Vendor Payment Report </h1>
            </div>
            <div class="peopple-managment-main">
                <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Vendor Name </label>
                                <input name="vendor_name" class="form-control" v-model="vendor_name" placeholder="Enter vendor name">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Account Number </label>
                                <input name="account_number" class="form-control" v-model="account_number" placeholder="Enter account number or Cnic">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Mode of Payment </label>
                                <select v-model="account_type" name="account_type" class="selectpicker custom-select2">
                                    <option value="" selected>Select Account Type</option>
                                    <option value="SIMSIM" v-if="$global.user_company_payment_engine == 'FINCA'">SIMSIM</option>
                                    <option value="EASY_PAISA_WALLET" v-if="$global.user_company_payment_engine == 'EASY_PAISA'">Easypaisa Wallet</option>
                                    <option value="EASY_PAISA_CNIC" v-if="$global.user_company_payment_engine == 'EASY_PAISA'">Easypaisa CNIC</option>
                                    <option value="IBFT">IBFT</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Vendor Category </label>
                                <select v-model="vendor_category" name="vendor_category" class="selectpicker custom-select2"  v-if="vendor_categories != null">
                                    <option value="" selected>Select Vendor Category</option>
                                    <option v-for="vendor_category in vendor_categories" v-bind:value="vendor_category.id" v-bind:key="vendor_category.id">
                                        {{ vendor_category.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Transaction ID </label>
                                <input name="transaction_id" class="form-control" v-model="transaction_id" placeholder="Enter Transaction ID">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Batch ID </label>
                                <input name="batch_id" class="form-control" v-model="batch_id" placeholder="Enter Batch ID">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Amount of Transfer </label>
                                <input name="amount_of_transfer" class="form-control" v-model="amount_of_transfer" placeholder="Enter Transfer Amount">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Vendor Number </label>
                                <input name="vendor_number" class="form-control" v-model="vendor_number" placeholder="Enter mobile number">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> From Date </label>
                                <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> To Date </label>
                                <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date" :value="new Date()"></datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
							<div class="form-group">
								<label class="label block-label"> Token ID </label>
								<input name="ep_cnic_token" class="form-control" v-model="ep_cnic_token" placeholder="Enter EasyPaisa Token ID">
							</div>
						</div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Payment Type</label>
                                <select v-model="payment_type" name="payment_type" class="selectpicker custom-select2">
                                    <option value="" selected>Select Payment Type</option>
                                    <option value="VENDOR">VENDOR</option>
                                    <option value="MERCHANT">MERCHANT</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group align-right">
                                <br>
                                <button @click="getVendorBatchReport" v-if="!showBtn" class="btn btn-primary">Search</button>
                                <button @click="filterTable" v-if="showBtn" class="btn btn-primary">Search</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="tab-content" id="myTabContent">
                <div v-show="!hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                    <div class="empty-main pt-0" style="height: 100px">
                        <div class="empty-inner">
                            <img src="/images/new_empty_payments.png" alt="" />
                            <h2> Hi, {{user}}! </h2>
                            <p> Select your requirements and export your desired report </p>
                        </div>
                    </div>
                </div>
                <div v-show="hasPer">
                    <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs" v-if="export_vendor_payment_report === true">
                        <div class="field-box export-attendance">
                            <button class="btn btn-primary export" @click="exportReport">Export Report</button>
                        </div>
                    </div>

                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="vendorPaymentReportTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th style="display: none">ID</th>
                                    <th>Name</th>
                                    <th>Account Type</th>
                                    <th>Payment Type</th>
                                    <th>Bank Name</th>
                                    <th>Account Number</th>
                                    <th>Mobile Number</th>
                                    <th>Category</th>
                                    <th>Purpose of Payment</th>
                                    <th>Net Payable</th>
                                    <th>Trasaction ID</th>
                                    <th>Batch ID</th>
                                    <th>Token ID</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="vendor_payment_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="vendor_payment_report === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
				vendor_name : '',
				account_number : '',
				vendor_category : '',
                account_type : '',
				payment_type : '',
                amount_of_transfer : '',
                vendor_number : '',
                transaction_id : '',
                batch_id : '',
				from_date : new Date(),
				to_date : new Date(),
				ep_cnic_token : '',
				// filter data
                vendor_categories : null,
				user: '',
				hasPer: false,
				showBtn: false,
				vendor_payment_report: null,
				export_vendor_payment_report: null,
				dtTable: null,
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
			this.can('vendor_payment_report|export_vendor_payment_report').then(result => {
                this.vendor_payment_report = result.vendor_payment_report;
                this.export_vendor_payment_report = result.export_vendor_payment_report;
                this.user = result.user_name;
            }).then(result => {
                if(this.vendor_payment_report == true){
        			this.loadFiltersData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
			loadFiltersData: function(){
                this.$Progress.start();
                axios.get('/api/vendor_batch_payment_report_data')
					.then(res => {
						if(res.status == 200){
							this.vendor_categories = res.data.vendor_categories;
							this.$Progress.finish();
						}else{
							this.$Progress.fail();
							this.showAlertBox('error','Error to load data');
						}
                    })
                    .then(res=>{
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
					.catch(err => {
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					});
			},
			exportReport: function(){
				this.$Progress.start();
				var formData = {
					'to_date': moment(this.to_date).format('YYYY-MM-DD'),
					'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                    'account_type': this.account_type,
					'payment_type': this.payment_type,
					'vendor_category': this.vendor_category,
					'account_number': this.account_number,
                    'vendor_name': this.vendor_name,
                    'amount_of_transfer': this.amount_of_transfer,
                    'vendor_number': this.vendor_number,
                    'transaction_id': this.transaction_id,
					'batch_id': this.batch_id,
					'ep_cnic_token': this.ep_cnic_token,
                }
                axios.post('/api/vendor_batch_payment_export', formData,{
					responseType: 'blob'
				})
				.then(res => {
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'vendorPaymentReport.xlsx')
					document.body.appendChild(link)
					link.click()
					this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load data');
				});
			},
			filterTable(){
                this.dtTable.ajax.reload(function()
				{
					gThat.dtTable.draw();
                }, false);
            },
            getVendorBatchReport: function(){
	            this.$Progress.start();
				var that = this;
				this.dtTable = $('#vendorPaymentReportTable').DataTable({
					sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
					processing: true,
					serverSide: true,
                    ordering:false,
					ajax: {
						"url": "api/vendor_batch_payment_report",
						"data": function (d) {
							d.vendor_name = that.vendor_name;
							d.account_number = that.account_number;
							d.vendor_category = that.vendor_category;
                            d.account_type = that.account_type;
                            d.payment_type = that.payment_type;
                            d.amount_of_transfer = that.amount_of_transfer;
                            d.vendor_number = that.vendor_number;
                            d.transaction_id = that.transaction_id;
							d.batch_id = that.batch_id;
							d.from_date = moment(that.from_date).format('YYYY-MM-DD');
							d.to_date = moment(that.to_date).format('YYYY-MM-DD');
							d.ep_cnic_token = that.ep_cnic_token;
						},
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
					deferRender: true,
					columns: [
						{data: 'id', visible: false},
						{render: function(data,type,full){
							if(full.name != null){
								return full.name;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.beneficiary && full.beneficiary.account_type != null){
                                return full.beneficiary.account_type;
							}else{
								return "---";
							}
						}},

                        {render: function(data,type,full){ 
                            return full.payee_type;
                        }},

						{render: function(data,type,full){
                            if(full.beneficiary && full.beneficiary.bank_name != null){
                                return full.beneficiary.bank_name;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.beneficiary && full.beneficiary.account_number != null){
								return full.beneficiary.account_number;
							}else{
								return "---";
							}
						}},
                        {render: function(data,type,full){
                            if(full.mobileNo != null){
                                return full.mobileNo;
                            }else{
                                return "---";
                            }
                        }},
                        { render: function(data, type, full) {
                            if (full.vendor && full.vendor.category != null) {
                                return full.vendor.category.name;
                            } else {
                                return "---";
                            }
                        }},
						{render: function(data,type,full){
							if(full.reason != null){
								return full.reason;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							var net_salary = new Intl.NumberFormat().format(full.net_salary);
							if(net_salary != null){
								return net_salary;
							}
						}},
						{render: function(data,type,full){
							if(full.transactionId != null){
								return full.transactionId;
							}else{
								return "---";
							}
						}},
                        {render: function(data,type,full){
                            if(full.payrollId != null){
                                return full.payrollId;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
						    return (full.transactionToken != null ? full.transactionToken : '---');
                        }},
						{render: function(data,type,full){
							var date = full['created_at'];
							return ''+moment(date).format('MMM D, Y')+'';
						}},
					],
					"order": [[ 0, "desc" ]],
					"initComplete": () => {
						that.hasPer = true;
						that.showBtn = true;
						this.$Progress.finish();
					}
				});
            }
        }
    }
</script>
